export default __webpack_public_path__ + "static/media/slider_7-md@2x.8df3c3f6.webp";